<template>
  <b-modal
    @shown="limpaModal"
    size="lg"
    id="ModalVigente"
    :no-close-on-backdrop="loading || loadingNcm"
    :no-close-on-esc="loading || loadingNcm"
  >
    <Header mini titulo="Atualização de NCM" icone="edit" cor="azul" slot="modal-header" />
    <template>
      <div class="modal-corpo">
        <LoadingPadraoContainer
          v-if="loading || loadingNcm"
          class="loading-padrao-backdrop"
          background
          :fraseLoading="['Procurando NCMs relacionadas', 'Aguarde um momento']"
          delay="5000"
          classe="azul"
        />

        <div v-if="loading" class="altura-loading"></div>
        <div v-else>
          <!-- {{ sugestoes.map(p=>p.selecionado) }} -->
          <!-- {{ sugestoes ? sugestoes[0] : "" }} -->
          <div class="modal-vigente-texto">
            <div>
              A NCM <b>{{ conteudo ? conteudo.ncm : "" }}</b> não se encontra vigente.
            </div>
            <div>
              Selecione uma NCM na lista abaixo para atualizar o cadastro do produto.
            </div>
          </div>
          <TabelaPadrao
            compacto
            templateColumns="120px 2fr"
            radio="50px"
            :conteudoPaginado="sugestoes"
            :conteudoTotal="sugestoes"
            :estruturaTabela="estruturaTabela"
            idRadio="id"
            @radioModel="update => (radioModel = update)"
            :radioModel="radioModel"
          />

          <!-- <div class="linha-sugestao" v-for="(item, index) in sugestoes" :key="index">
            <div>
              {{ item.ncm }}
            </div>
            <div>
              {{ item.descricao }}
            </div>
          </div> -->
        </div>
      </div>
    </template>
    <template slot="modal-footer">
      <BotaoPadrao
        arredondadoEsquerda
        class="botao-modal"
        nome="Cancelar"
        icone="times"
        :click="cancelar"
        :desabilita="loading || loadingNcm"
      />
      <BotaoPadrao
        v-if="blUsuarioPro"
        arredondadoEsquerda
        class="botao-modal"
        nome="Selecionar"
        icone="check"
        :click="handleClick"
        :loading="loadingNcm"
        desabilita
        cor="azul"
        tooltip="Opção desabilitada na versão de testes"
      />
      <BotaoPadrao
        v-else
        arredondadoEsquerda
        class="botao-modal"
        nome="Selecionar"
        icone="check"
        :click="handleClick"
        :loading="loadingNcm"
        :desabilita="!ncmSelecionada || loading || loadingNcm"
        cor="azul"
      />
    </template>
  </b-modal>
</template>

<script>
import TabelaPadrao from "@/components/TabelaPadrao/TabelaPadrao.vue";
import BotaoPadrao from "@/components/BotaoPadrao/BotaoPadrao.vue";
import Header from "@/components/ModalComponente/Header.vue";
import LoadingPadraoContainer from "@/components/LoadingPadrao/LoadingPadraoContainer.vue";

import { mapGetters } from "vuex";
import Api from "@/services/api.js";

export default {
  name: "ModalLimpar",
  components: {
    BotaoPadrao,
    Header,
    TabelaPadrao,
    LoadingPadraoContainer
  },
  props: {
    conteudo: Object
  },
  data() {
    return {
      radioModel: null,
      loading: false,
      loadingNcm: false,
      sugestoes: [],
      estruturaTabela: [
        { nome: "NCM", valor: "ncm", alinhamento: "centro" },
        { nome: "DESCRIÇÃO", valor: "descricao" }
      ]
    };
  },
  created() {
    window.addEventListener("keydown", this.handleKey);
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.handleKey);
  },
  watch: {
    conteudo: {
      deep: true,
      async handler() {
        await this.obtemSugestoes();
      }
    }
  },
  computed: {
    ...mapGetters("auth", {
      blUsuarioPro: "getUsuarioPro"
    }),

    ncmSelecionada() {
      if (this.radioModel) {
        let ncm = this.sugestoes.find(f => f.id == this.radioModel);
        return ncm ? ncm : null;
      }
      return null;
    }
  },
  methods: {
    limpaModal() {
      this.radioModel = null;
      if (this.conteudo && !this.sugestoes.length) {
        this.obtemSugestoes();
      }
    },
    atualizaLista() {
      this.$emit("atualiza");
    },
    alteraConteudo(conteudo) {
      this.sugestoes = conteudo;
    },
    async obtemSugestoes() {
      this.loading = true;
      try {
        let response = await new Api().get(
          `Produto/obterSugestoes/${this.conteudo.id_empresa}/${this.conteudo.id}`
        );
        let sugestoes = response.dados.sugestoes.filter(f => !!f.vigente);
        sugestoes.forEach(e => (e.selecionado = false));
        this.sugestoes = sugestoes;
      } catch (error) {
        console.error(error);
      }
      this.loading = false;
    },
    async alteraNcm() {
      this.loadingNcm = true;
      let payload = {
        ncm: this.ncmSelecionada.ncm,
        ex: this.ncmSelecionada.ex ? this.ncmSelecionada.ex : 0
      };
      await new Api().post(`Produto/alterarNcm/${this.conteudo.id}`, payload);
      this.loadingNcm = false;
    },
    async handleKey(event) {
      let modal = document.getElementById("ModalVigente");
      if (modal.classList.contains("show")) {
        if (event.key === "Enter") {
          await this.alteraNcm();
          this.$root.$emit("bv::hide::modal", "ModalVigente");
        }
      }
    },
    async handleClick() {
      await this.alteraNcm();
      this.$root.$emit("bv::hide::modal", "ModalVigente");
      this.atualizaLista();
    },
    cancelar() {
      this.$root.$emit("bv::hide::modal", "ModalVigente");
    }
  }
};
</script>

<style lang="scss">
.modal-cabecalho {
  display: flex;
  flex-direction: column;
  align-items: center !important;
  justify-content: center;
}
.modal-cabecalho-interno {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.modal-icone-limpar {
  font-size: 40px;
  margin: 5px 0;
  color: var(--azul2);
}
.modal-corpo {
  text-align: center;
}
.botao-modal {
  margin: 0 0 0 10px !important;
}
.linha-sugestao {
  display: flex;
}
.modal-vigente-texto {
  margin-bottom: 14px;
}
.altura-loading {
  width: 100%;
  height: 80px;
}
.loading-modal-vigente {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 1000;
  background: #00000033;
  color: var(--branco);
  font-size: 40px;
}
</style>
